import { Company } from "./Company";
import { StoreIntegration } from "./StoreIntegration";
import { Validate } from "./Validate";

export interface Article {
  id: string;
  creationDate: string;
  creationUser: string;
  lastModifiedDate: string;
  lastModifiedUser: string;
  ownerId: string;
  owner: Company;
  sourceIntegrationId: string;
  sourceIntegration: StoreIntegration;
  sourceType: string;
  name: string;
  internalReference: string;
  externalReference: string;
  sourceReference: string;
  height?: number;
  length?: number;
  width?: number;
  weight?: number;
  weightUnit: string;
  currency: string;
  originalPrice: number;
  price: number;
  barcode: string;
  barcodeType: string;
  sku: string;
  asin: string;
  taxCode: string;
  shippingRequired: boolean;
  originCountryCode: string;
  hs: string;
  parentId: string;
  bodyHtmlUrl: string;
  type: string;
  vendor: string;
  sourceCreationDate: string;
  sourceUpdateDate: string;
  uniqueBarcodeItem: boolean;
  pub: boolean;
  imageUrl?: string;
  totalAvailable?: number;
  vat?: number;
}

export interface CreateArticle {
  ownerId?: string;
  vat: number;
  pub: boolean;
  shippingRequired: boolean;
  uniqueBarcodeItem: boolean;
}

export const defaultCreateArticle: CreateArticle = {
  vat: 22,
  pub: false,
  shippingRequired: false,
  uniqueBarcodeItem: false,
};

// Interface for PUT (to update an existing Article)
export interface UpdateArticle {
  id: string;
  name?: string | null;
  ownerId: string;
  sourceIntegrationId?: string;
  externalReference?: string;
  vendor?: string;
  type?: string;
  price?: number;
  originalPrice?: number;
  vat?: number;
  pub: boolean;
  shippingRequired: boolean;
  uniqueBarcodeItem: boolean;
  barcode?: string;
  height?: number;
  length?: number;
  width?: number;
  weight?: number;
}

// Convert function to update
export const convertArticleToUpdate = (article: Article): UpdateArticle => {
  return {
    id: article.id,
    ownerId: article.ownerId,
    sourceIntegrationId: article.sourceIntegration?.id,
    name: article.name,
    externalReference: article.externalReference,
    vendor: article.vendor,
    type: article.type,
    price: article.price,
    originalPrice: article.originalPrice,
    vat: article.vat,
    pub: article.pub,
    shippingRequired: article.shippingRequired,
    uniqueBarcodeItem: article.uniqueBarcodeItem,
    barcode: article.barcode,
    width: article.width,
    height: article.height,
    length: article.length,
    weight: article.weight,
  };
};

export const validate = (article: Article): Validate => {
  const validate: Validate = { isValid: true, errors: {} };
  return validate;
};
